/**
 * @name SimpleLogo
 * @author Keven Adan Bezerra | kevenadanb
 * @description Componente simples de logo sem navegação para uso em loaders
 * @returns {JSX.Element} - JSX do componente.
 * @package src/contexts/LoadingContext/SimpleLogo.tsx
 */

import { styled } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";

const StyledLogo = styled("img")({
  display: "block",
  maxWidth: "100%",
  height: "auto",
  cursor: "default", // Sem cursor de ponteiro pois não navega
});

interface SimpleLogoProps {
  src: string;
  alt?: string;
  width?: string | number;
  height?: string | number;
}

const SimpleLogo: React.FC<SimpleLogoProps> = ({
  src,
  alt = "Logo",
  width,
  height,
}) => {
  return (
    <Box
      component="div"
      sx={{
        width: width || "auto",
        height: height || "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <StyledLogo src={src} alt={alt} style={{ width, height }} />
    </Box>
  );
};

export default SimpleLogo;
